import React, { useEffect, useState } from 'react'
import useStyles from '../Table/useStyles'
import TableHead from './TableHead'
import TableBody from './TableBody'
import ColumnType from './Column.interface'
import Typography from '../Typography/Typography'

interface PropsInterface {
    caption?: string;
    className?: string
    /** Replace the default section styles for app-specific table designs. */
    classes?: { head?: string, body?: string }
    columns: ColumnType[],
    data: Record<string, unknown>[];
    loading?: boolean
    scrollAfterRow?: number
    sortingCb?(field, order, tableData): Record<string, unknown>[];
    'data-testid'?: string;

}

type dataType = Record<string, unknown>[] | undefined

const defaultSorting = (sortField, sortOrder, tableData): dataType => {
    if (sortField) {
        const sorted = [...tableData].sort((a, b) => {
            if (a[sortField] === null) return 1
            if (b[sortField] === null) return -1
            if (a[sortField] === null && b[sortField] === null) return 0
            return (
                a[sortField].toString().localeCompare(b[sortField].toString(), 'en', {
                    numeric: true
                }) * (sortOrder === 'asc' ? 1 : -1)
            )
        })
        return sorted
    }
}
/**
 *
 */
const Table = ({
    caption,
    className = '',
    classes = {},
    columns,
    data,
    loading = false,
    scrollAfterRow,
    sortingCb = defaultSorting,
    'data-testid': dataTestId = 'table'
}: PropsInterface): JSX.Element => {
    const styles = useStyles({ color: 'neutral-50' })

    const [tableData, setTableData] = useState(data)

    useEffect(() => {
        setTableData(data)
    }, [data])

    const handleSorting = (field, order) => {
        if (sortingCb) {
            const res = sortingCb(field, order, [...tableData])
            if (res) {
                setTableData(res)
            }
        }
    }

    return <table className={`${styles.table} ${className}`} data-testid={dataTestId}>
        {caption && <Typography variant='captionHeavy'>{caption}</Typography>}
        <TableHead
            columns={columns}
            className={classes.head}
            handleSorting={handleSorting}
            data-testid={`${dataTestId}-head`}
        />
        <TableBody
            className={classes.body}
            columns={columns}
            data={tableData}
            loading={loading}
            scrollAfterRow={scrollAfterRow}
            data-testid={`${dataTestId}-body`}
        />
    </table>
}

/**
 *
 */
export type TableType = PropsInterface

export default Table
